import React from "react";
import { Helmet } from "react-helmet-async";

const About = () => {
  return (
    <div className="min-h-screen bg-[#111111] text-[#f1f1f1] font-roboto px-4 py-16 flex items-start justify-center">
      <Helmet>
        <title>About SeguraTech | Trusted Security Specialist in Sussex</title>
        <meta
          name="description"
          content="Learn about SeguraTech, a Sussex based security specialist built on experience in close protection and military service, delivering reliable and considered security solutions."
        />
      </Helmet>

      <div className="bg-[#1a1a1a] border border-[#C6A564] rounded-2xl shadow-xl shadow-black/40 p-10 max-w-2xl w-full animate-fadeIn">
        {/* Logo */}
        <img
          src="/SeguraTechLogo.png"
          alt="SeguraTech security company logo"
          className="mx-auto mb-8 w-44"
        />

        {/* Heading */}
        <h1 className="text-2xl font-semibold mb-6 text-center text-[#C6A564]">
          About SeguraTech
        </h1>

        <p className="text-white/90 mb-5 leading-relaxed text-sm">
          I began my career in close protection and quickly learned that real
          security is not about presence or visibility. It is about trust,
          preparation, and giving people genuine peace of mind.
        </p>

        <p className="text-white/90 mb-5 leading-relaxed text-sm">
          My time in the military reinforced the importance of honesty,
          integrity, and attention to detail. Those principles continue to guide
          every decision I make and every system I design.
        </p>

        <p className="text-white/90 mb-5 leading-relaxed text-sm">
          At SeguraTech, the focus is on creating calm, reliable environments
          where families and individuals can feel secure without feeling
          overwhelmed by technology. Every installation is approached with care,
          clarity, and respect for the people who live with it.
        </p>

        <p className="text-white/90 leading-relaxed text-sm">
          Every job is personal to me. I take pride in delivering on what is
          promised, communicating clearly, and standing by my work long after
          the installation is complete.
        </p>

        <p className="italic text-[#C6A564] text-sm mt-8 text-center">
          “Security built on trust, delivered with precision.”
        </p>
      </div>
    </div>
  );
};

export default About;
